function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useContext } from "react";
import TerriaError from "../../Core/TerriaError";
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewStateContext = /*#__PURE__*/createContext(undefined);
export const ViewStateProvider = _ref => {
  let {
    viewState,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(ViewStateContext.Provider, {
    value: viewState,
    children: children
  });
};
export const useViewState = () => {
  const viewState = useContext(ViewStateContext);
  if (!viewState) throw new TerriaError({
    message: "ViewState is not defined!"
  });
  return viewState;
};
export const withViewState = Component => function withViewState(props) {
  return /*#__PURE__*/_jsx(ViewStateContext.Consumer, {
    children: viewState => {
      if (!viewState) throw new TerriaError({
        message: "ViewState is not defined!"
      });
      return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
        viewState: viewState
      }));
    }
  });
};